/* ─────────────────────────────────────────────────
   APPLE-STYLE SHOPIFY THEME — theme.js
   ───────────────────────────────────────────────── */

document.addEventListener('DOMContentLoaded', () => {

  /* ── Sticky header shadow ── */
  const header = document.getElementById('site-header');
  if (header) {
    window.addEventListener('scroll', () => {
      header.classList.toggle('scrolled', window.scrollY > 10);
    }, { passive: true });
  }

  /* ── Mobile menu ── */
  const mobileToggle = document.getElementById('mobile-menu-toggle');
  const mobileMenu   = document.getElementById('mobile-menu');
  if (mobileToggle && mobileMenu) {
    mobileToggle.addEventListener('click', () => {
      const open = mobileMenu.classList.toggle('open');
      mobileToggle.setAttribute('aria-expanded', open);
      mobileMenu.setAttribute('aria-hidden', !open);
    });
  }

  /* ── Search bar ── */
  const searchToggle = document.getElementById('search-toggle');
  const searchBar    = document.getElementById('search-bar');
  if (searchToggle && searchBar) {
    searchToggle.addEventListener('click', () => {
      const open = searchBar.classList.toggle('open');
      searchBar.setAttribute('aria-hidden', !open);
      if (open) searchBar.querySelector('.search-input')?.focus();
    });
    document.addEventListener('keydown', e => {
      if (e.key === 'Escape') { searchBar.classList.remove('open'); }
    });
  }

  /* ── Hero Slideshow ── */
  const slider = document.getElementById('hero-slider');
  const dotsContainer = document.getElementById('hero-dots');
  if (slider) {
    const slides = Array.from(slider.querySelectorAll('.hero-slide'));
    let current = 0;
    let timer;

    // Build dots
    if (dotsContainer) {
      slides.forEach((_, i) => {
        const dot = document.createElement('button');
        dot.className = 'hero-dot' + (i === 0 ? ' active' : '');
        dot.setAttribute('aria-label', `Slide ${i + 1}`);
        dot.addEventListener('click', () => goTo(i));
        dotsContainer.appendChild(dot);
      });
    }

    function applyBg(slide) {
      const bg = slide.dataset.bg || '#f5f5f7';
      slider.style.background = bg;
    }

    function goTo(idx) {
      slides[current].classList.remove('active');
      dotsContainer?.children[current]?.classList.remove('active');
      current = idx;
      slides[current].classList.add('active');
      dotsContainer?.children[current]?.classList.add('active');
      applyBg(slides[current]);
      resetTimer();
    }

    function resetTimer() {
      clearTimeout(timer);
      const speed = (parseInt(slider.closest('[data-autoplay]')?.dataset.autoplay) || 5) * 1000;
      timer = setTimeout(() => goTo((current + 1) % slides.length), speed);
    }

    if (slides.length > 0) {
      applyBg(slides[0]);
      resetTimer();
    }
  }

  /* ── Add to Cart (AJAX) ── */
  document.addEventListener('click', async e => {
    const btn = e.target.closest('.btn-add-to-cart');
    if (!btn || btn.disabled) return;

    const variantId = btn.dataset.variantId;
    if (!variantId) return;

    btn.disabled = true;
    const originalText = btn.textContent;
    btn.textContent = 'Adding…';

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 }),
      });

      if (res.ok) {
        const item = await res.json();
        btn.textContent = '✓ Added';
        btn.classList.add('added');
        showCartToast(item.title);
        updateCartCount();
        setTimeout(() => {
          btn.textContent = originalText;
          btn.classList.remove('added');
          btn.disabled = false;
        }, 2200);
      } else {
        btn.textContent = 'Error';
        setTimeout(() => { btn.textContent = originalText; btn.disabled = false; }, 1500);
      }
    } catch {
      btn.textContent = originalText;
      btn.disabled = false;
    }
  });

  /* ── Product form (product page) ── */
  const productForm = document.getElementById('product-form');
  if (productForm) {
    productForm.addEventListener('submit', async e => {
      e.preventDefault();
      const btn = productForm.querySelector('#add-to-cart-btn');
      const variantId = productForm.querySelector('#variant-id')?.value;
      const qty = parseInt(productForm.querySelector('#qty-input')?.value) || 1;
      if (!variantId || !btn) return;

      const orig = btn.textContent;
      btn.disabled = true;
      btn.textContent = 'Adding…';

      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: qty }),
        });
        if (res.ok) {
          const item = await res.json();
          btn.textContent = '✓ Added to Cart';
          btn.classList.add('added');
          showCartToast(item.title);
          updateCartCount();
          setTimeout(() => { btn.textContent = orig; btn.classList.remove('added'); btn.disabled = false; }, 2200);
        } else {
          btn.textContent = orig; btn.disabled = false;
        }
      } catch { btn.textContent = orig; btn.disabled = false; }
    });
  }

  /* ── Quantity selector ── */
  document.addEventListener('click', e => {
    const btn = e.target.closest('.qty-btn');
    if (!btn) return;
    const input = btn.closest('.qty-selector')?.querySelector('.qty-input');
    if (!input) return;
    let val = parseInt(input.value) || 1;
    if (btn.dataset.action === 'increase') val = Math.min(val + 1, 99);
    if (btn.dataset.action === 'decrease') val = Math.max(val - 1, 1);
    input.value = val;
  });

  /* ── Product gallery thumbnails ── */
  document.addEventListener('click', e => {
    const thumb = e.target.closest('.gallery-thumb');
    if (!thumb) return;
    document.querySelectorAll('.gallery-thumb').forEach(t => t.classList.remove('active'));
    thumb.classList.add('active');
    const mainImg = document.getElementById('gallery-main-image');
    if (mainImg && thumb.dataset.src) mainImg.src = thumb.dataset.src;
  });

  /* ── Variant selector ── */
  document.addEventListener('click', e => {
    const btn = e.target.closest('.variant-btn');
    if (!btn) return;
    const group = btn.closest('.variant-group');
    group?.querySelectorAll('.variant-btn').forEach(b => b.classList.remove('selected'));
    btn.classList.add('selected');
    const option = btn.dataset.option;
    const value  = btn.dataset.value;
    const label  = document.getElementById(`selected-${option}`);
    if (label) label.textContent = value;
    updateVariant();
  });

  function updateVariant() {
    // Collect selected options
    const selected = {};
    document.querySelectorAll('.variant-btn.selected').forEach(b => {
      selected[b.dataset.option] = b.dataset.value;
    });

    // Find matching variant from Shopify's product JSON
    const productData = window.__productVariants;
    if (!productData) return;

    const match = productData.find(v =>
      v.options.every((opt, i) => {
        const key = `option${i+1}`;
        return Object.values(selected)[i] === opt;
      })
    );

    if (match) {
      const idInput = document.getElementById('variant-id');
      const priceEl = document.getElementById('product-price');
      const addBtn  = document.getElementById('add-to-cart-btn');
      if (idInput) idInput.value = match.id;
      if (priceEl) priceEl.textContent = formatMoney(match.price);
      if (addBtn) {
        addBtn.disabled = !match.available;
        addBtn.textContent = match.available ? 'Add to Cart' : 'Sold Out';
      }
    }
  }

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  /* ── Cart toast ── */
  function showCartToast(title) {
    const toast = document.getElementById('cart-toast');
    if (!toast) return;
    toast.innerHTML = `<span style="color:#34c759;margin-right:8px">✓</span> ${title.substring(0, 40)} added`;
    toast.classList.add('show');
    clearTimeout(toast._timer);
    toast._timer = setTimeout(() => toast.classList.remove('show'), 2500);
  }

  /* ── Update cart count in header ── */
  async function updateCartCount() {
    try {
      const res = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
      if (!res.ok) return;
      const cart = await res.json();
      const badges = document.querySelectorAll('.cart-badge');
      badges.forEach(b => {
        b.textContent = cart.item_count;
        b.style.display = cart.item_count > 0 ? 'flex' : 'none';
      });
    } catch {}
  }

});

/* ============ LANGUAGE SWITCHER FLAGS ============ */
document.addEventListener('DOMContentLoaded', function() {
  var langFlags = { 'ro': '🇷🇴 RO', 'en': '🇬🇧 EN' };
  var selects = document.querySelectorAll('.lang-select');
  selects.forEach(function(select) {
    Array.from(select.options).forEach(function(opt) {
      var code = opt.value.toLowerCase().split('-')[0];
      if (langFlags[code]) opt.text = langFlags[code];
      else opt.text = code.toUpperCase();
    });
  });
});

/* ============ FIX MOBILE MENU DROPDOWN BELOW ANNOUNCEMENT BAR ============ */
document.addEventListener('DOMContentLoaded', function() {
  var header = document.getElementById('site-header');
  var annBar = document.querySelector('.announcement-bar');
  var mobileNav = document.getElementById('mobile-nav');
  
  function updateMobileNavTop() {
    if (!mobileNav) return;
    var headerH = header ? header.offsetHeight : 60;
    var annH = annBar ? annBar.offsetHeight : 0;
    mobileNav.style.top = (headerH + annH) + 'px';
  }
  
  updateMobileNavTop();
  window.addEventListener('resize', updateMobileNavTop);
  
  // Also update CSS variable for nav height dynamically
  if (header) {
    var navH = header.offsetHeight;
    document.documentElement.style.setProperty('--nav-h', navH + 'px');
  }
});